// extracted by mini-css-extract-plugin
export default {"box":"advertisementPage_box__B64bp"};